module.exports = __webpack_public_path__ + "img/logo.4f1d48aa.png";